import { Component, NgModule, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Apollo } from 'apollo-angular';

import { LoginService } from './../../services/login.service';
import { MatIconModule } from '@angular/material/icon';

import { UsuariosService } from 'src/app/services/usuarios.service';
import { EmailService } from 'src/app/services/email.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  datosUser: any={};
  public user: any;
  public password: any;
  public invalidUser: boolean;
  hide = true;
  
  constructor(private formBuilder: FormBuilder, private apollo: Apollo, private loginService: LoginService, private router: Router, private userService: UsuariosService ,private emailService: EmailService) {
    this.invalidUser = false;
    this.buildForm();
  }

  ngOnInit(): void {
  }

  private buildForm(){
    this.datosUser = this.formBuilder.group({
      user: ['', [Validators.required]],
      password: ['',[Validators.required]],
    });
  }

  

  setCredentials(){
    this.user = this.datosUser.value.user
    this.password = this.datosUser.value.password
  }

  handleLogin(){
    this.setCredentials()
    this.apollo.mutate<any>({
      mutation: this.loginService.login(),
      variables: {
        "input": {
          "identifier": this.user,
          "password": this.password
        }
      }
    }).subscribe(async ({data}) => {
      console.log('OK', data)
      
      await this.getUserLogged(data.login.user.id)
      this.loginService.setUserToken(data.login.jwt)

      //TODO REDIRIGIR EN FUNCIÓN DEL ROL (CLIENTE, CONTRATISTA, INPROECO...)
      //this.router.navigate(['inproeco/inicio'])

      this.invalidUser = false;
    }, (error) => {
      this.invalidUser = true
      console.log('Error al lanzar la query', error);
    })
  }

  getUserLogged(id: string){
    this.apollo.watchQuery<any>({
      query: this.userService.getUsuariosById(),
      variables: {
        id,
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        
        this.loginService.setUserData(data.user)

        if(data.user.cliente){
          this.router.navigate(['cliente/inicio'])
        } else if(data.user.contratista){
          this.router.navigate(['contratista/inicio'])
        } else {
          this.router.navigate(['inproeco/inicio'])
        }
      })
  }
}
